export default __webpack_public_path__ + "static/media/Icon-User-Outline-Users.5f887520.svg";